import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDPaper, FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ErrorList from 'Components/UI/ErrorList';

const ManagedAccountDisclaimersMessageLayout = () => {
  const {
    resource, onSubmit, saving, errors,
  } = useMetaLayoutContext();

  return (
    <FDPaper width={'100%'} appearance={'flat'} color={'subtle'} padding={6}>
      <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'} spacing={4}>
        <MetaControlField attr={'successText'} />
        <MetaControlField attr={'disclaimers'} />
        {resource.meta().canSubmit() ? (
          <FDPrimaryActionButton
            label={'Submit'}
            size={'lg'}
            isFullWidth
            disabled={saving || !resource.meta().canSubmit()}
            loading={saving}
            onClick={onSubmit}
          />
        ) : null}
        <ErrorList title={'Errors occurred while submitting'} errors={errors} />
      </FDStack>
    </FDPaper>
  );
};

ManagedAccountDisclaimersMessageLayout.defaultProps = {};

ManagedAccountDisclaimersMessageLayout.propTypes = {};

export default ManagedAccountDisclaimersMessageLayout;
